<template>
  <div class="vuse-content-wrapper chat-app">
    <v-row >
      <v-col cols="12" md="6" class="mt-0">
        <h2 class="ml-3 float-left">
          {{$t(page+'.Tickets')}}
        </h2>
      </v-col>
    </v-row>
    <inner-base-layout
      baseLayerClass="neu-glow-inset_s"
      innerContainerClass="transparent"
    >
      <template v-slot:sidebar>
        <user-list-nav
          :drawer="drawer"
          :items="filteredGroups"
          :clicked="switchGroup"
          :activeId="activeGroupId"
          :onToggle="drawerHandler"
        >
          <v-text-field
            v-model="search"
            :label="$t(page+'.Search Ticket')"
            solo
            dense
            flat
            prepend-icon="search"
            hide-details
          ></v-text-field>
        </user-list-nav>
      </template> 
      <div>
        <v-row>
          <v-col cols="12" md="4">           
            <v-row>
              <v-col cols="12" sm="12" class="mt-1 pb-0 pt-4 ml-1 pr-0">
                <v-card :height="wIH/1-460">
                  <div class="scrollable-content" ref="conversations" v-if="conversations" 
                    style="background-color:#efeae2;background-image:url('/static/bg.png');background-repeat-x:repeat;"
                  >
                    <v-card-text>
                      <v-slide-y-transition group tag="div" class="row">
                        <v-col cols="8" :class="authUser.id === thread.user_id?'offset-4':''"  v-for="(thread, index) in chat" :key="index">
                          <v-sheet
                            style="background-color:transparent"
                            class="d-flex"
                            :class="[
                              authUser.id === thread.user_id
                                ? 'flex-row-reverse'
                                : 'flex-row',
                            ]"
                          >
                            <div>
                              <v-avatar size="40px" color="grey lighten-4">
                                <img :src="thread.avatar" :alt="thread.user.name" />
                              </v-avatar>
                            </div>
                            <v-sheet
                              class="mx-3 pa-3"
                              :class="
                              authUser.id === thread.user_id
                              ? 'mymsg rounded'
                              : 'rounded'"
                            >
                              <v-div v-if="authUser.id === thread.user_id"><v-icon @click="deleteTicket(thread)" x-small class="float-right mt-n2">fas fa-times</v-icon></v-div>
                              <div class="mr-8" v-html="thread.message "></div>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-bind="attrs" v-on="on" style="font-size: 70%" class="mt-1 mb-n3 float-right" >
                                    {{new Date(thread.created_at*1000).toLocaleTimeString('it',{ hour12: false, hour: '2-digit', minute: '2-digit' })}} 
                                    <img 
                                      v-if="authUser.id === thread.user_id"
                                      class="float-right" 
                                      :src="thread.read?'/static/dblcheck_blue.svg':'/static/dblcheck.svg'" 
                                      :lazy-src="thread.read?'/static/dblcheck_blue.svg':'/static/dblcheck.svg'" />
                                </div>
                                </template>
                                <span>
                                  {{new Date(thread.created_at*1000).toLocaleString('it')}}
                                </span>
                              </v-tooltip>
                            </v-sheet>
                          </v-sheet>
                        </v-col>
                      </v-slide-y-transition>
                    </v-card-text>
                  </div>
                </v-card>
              </v-col>
             
              <v-col cols="12" md="12" class="pb-0 pt-0 pr-0 ml-0">
                <!--
                  <vue-editor v-model="chatMessageEditor" useCustomImageHandler @imageAdded="handleImageAdded" :editorToolbar="customToolbar"  class="ma-2" />
                  <vue-editor id="editor1" v-model="chatMessageEditor" :editorToolbar="customToolbar"  class="ma-2" />
                  //https://www.vue2editor.com/examples/#basic-setup
                -->
                <vue-editor id="editor1" v-model="chatMessageEditor" :editorToolbar="customToolbar"  class="ma-2" />
              </v-col>
              <!--
              <v-col cols="12" md="1" class="pl-0 pr-1 pt-2">
                <template v-if="quick">
                  <template v-for="(b,i) in quick" >
                    <v-tooltip top :key="i">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                          block
                          x-small
                          class="float-left mb-2" 
                          :color="b.color" 
                          :key="i" 
                          v-bind="attrs"
                          v-on="on" 
                          @click="addTextToChatMessageEditor(b.description)"
                        v-html="b.title"></v-btn>
                      </template>
                      <span v-html="b.description"></span>
                    </v-tooltip>
                  </template>
                </template>
              </v-col>              
              <v-col cols="12" md="1" class="pl-0 pt-2 pr-1">
                <template v-if="quick2">
                  <template v-for="(b,i) in quick2">
                    <v-tooltip top :key="i">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                          block
                          x-small
                          class="float-left mb-2" 
                          :color="b.color" 
                          :key="i" 
                          v-bind="attrs"
                          v-on="on" 
                          @click="addTextToChatMessageEditor(b.description)"
                        v-html="b.title"></v-btn>
                      </template>
                      <span v-html="b.description"></span>
                    </v-tooltip>
                  </template>
                </template>           
              </v-col>
              -->              

              <v-col cols="12" md="12" class="pb-0 pt-0 pr-0 ml-0">
                <v-btn small :disabled="chatMessageEditor==''" @click="chatMessageEditor=''" class="warning ml-3" >{{$t(page+'.Clear')}}</v-btn>
                <v-btn small :disabled="chatMessageEditor==''" @click="addTicket()" class="primary float-right mr-3" >{{$t(page+'.Send')}}</v-btn>
              </v-col>

            </v-row>
          </v-col>
          <v-col cols="12" md="8">
            <v-card>
              <v-row>
                <v-col cols="4" md="4">
                  <v-card-title class="text-h5 mb-3"
                    >{{$t(page+'.FAQ')}}
                  </v-card-title>
                </v-col>
                <v-col cols="4" md="4">
                  <v-text-field
                    v-model="FAQsearch"
                    append-icon="search"
                    :label="$t(page+'.Search')"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="4" md="4">
                  <v-btn
                    color="primary"
                    class="float-right ma-3"
                    @click="newTicketOpen()"
                  >
                    <v-icon class="mr-2">fas fa-ticket-alt</v-icon>
                    {{$t(page+'.New Ticket')}}
                  </v-btn> 
                </v-col>
              </v-row>
              <v-tabs
                v-model="FAQTab"
                background-color="transparent"
              >
                <v-tab
                  v-for="item in topics"
                  :key="item"
                >
                  {{ item.topic }}
                </v-tab>
              </v-tabs>
                
              <v-tabs-items v-model="FAQTab" >
                <v-tab-item
                  v-for="t in topics"
                  :key="t.topic"
                >
                  <v-card :height="wIH/1-276" style="overflow-y:scroll">
                    <v-card-text v-if="faqs">
                      <v-expansion-panels>
                        <v-expansion-panel
                          v-for="faq in faqs.filter(f => (f.topic==t.topic && f.tags &&f.tags.toLowerCase().includes(FAQsearch.toLowerCase())))"
                          :key="faq.faqId"
                          @click="rating=0"
                        >
                          <v-expansion-panel-header>
                            {{faq.question}}
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-row>
                              <v-col>
                                <div :ref="'d'+t.topic+faq.faqId" :id="'d'+t.topic+faq.faqId" v-html="faq.answer"  class="float-left font-weight-black text-body-1"></div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col class="py-0"> 
                                <v-spacer></v-spacer>
                                <v-div class="float-right">                                 
                                  <v-rating
                                    v-model="faq.rating"
                                    @input="RateFAQ($event,faq.faqId)"
                                    color="green"
                                    background-color="green lighten-3"
                                    half-increments
                                    hover
                                    length="5"
                                    size="25"
                                    :readonly="faq.rating"
                                     class="float-right"
                                  ></v-rating>
                                  <v-div v-if="!faq.rating" class="mt-3 float-left text-body-1">{{$t(page+'.Rate this Answer')}}:</v-div>
                                  <v-div v-else class="mt-3 mr-3 float-left text-body-1">{{$t(page+'.Rated on') + ' ' + faq.createdDate + ': ' }}</v-div>
                                </v-div>
                              </v-col>
                            </v-row>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>              
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>

          <!--
          <v-col cols="12" md="3" class="px-2 ml-n3 mt-5" style="border:1px solid #cacaca">
            <right-window
              v-if="groups!=null"
              :group="activeGroup||[]"
            />
          </v-col> 
          -->           
        </v-row>
      </div>        
    </inner-base-layout>
    <v-dialog v-model="tkt_dialog" max-width="900">
      <v-card>
        <v-card-title class="text-h5 mb-3"
          >{{$t(page+'.Create new Ticket')}}</v-card-title
        >
        <v-row class="mx-5">
          <v-col md="12" cols="12">
            <v-autocomplete
              v-model="tkt.topic"
              :items="topics"
              :filter="topicFilter"
              :search-input.sync="searchs"
              :label="$t(page+'.Topic')"
              outlined
              hide-details
            >

              <template v-slot:item="{ item }">
                <v-div :class="item.deptName==''?'red--text':''">
                  {{ item.topic }}
                </v-div>
              </template>
              <template v-slot:selection="{ item }">
                  {{item.topic}}
              </template>
            
            </v-autocomplete>  
            <!--           
            <v-combobox
              v-model="tkt.topic"
              :items="topics.map(t => t.topic)"
              :search-input.sync="searchs"
              :label="$t(page+'.Topic')"
              outlined
              hide-details
              clearable
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title v-htlm="$t(page+'.No results matching') + '<strong>{{ searchs }}</strong>.' + $t(page+'.Press Enter to create a new one')">
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>                    
            </v-combobox> 
            -->
          </v-col>
          <v-col md="8" cols="12">
            <v-text-field
                color="primary"
                :label="$t(page+'.Title')"
                v-model="tkt.title"
                class="mt-0"
                outlined
                dense
                counter
            ></v-text-field>
          </v-col>            
          <v-col md="4" cols="12">
            <v-text-field
                @keyup="searchTracking()"
                color="primary"
                :label="$t(page+'.Tracking ID if applicable')"
                v-model="tkt.trackingId"
                class="mt-0"
                :hint="searchHints"
                :persistent-hint="searchHints"
                :error="!prc&&tkt.trackingId&&tkt.trackingId.length>10"
                :success="prc"
                outlined
                dense
                counter
            ></v-text-field>
          </v-col>  
          <v-col md="12" cols="12" class="px-0">
            <vue-editor id="editor2" v-model="tkt.body" :editorToolbar="customToolbar"  class="ma-2" />
          </v-col>
              
        </v-row>
        <v-card-actions>
          <v-btn color=""  @click="tkt_dialog=false;tktSaved=false">
            {{$t(page+'.Close')}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="!tktSaved" :disabled="tkt.body==''" color="primary" :loading="tkt_loading"  @click="createTicket()">
            {{$t(page+'.Send')}}
          </v-btn>
          <v-btn v-else color="info" disabled  @click="tkt_dialog=false">
            {{$t(page+'.Saved')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :color="snackbar_color" :timeout="snackbar_timeout" >
      <span>{{snackbar_message}}</span>
    </v-snackbar>    
  </div>
</template>
<style>
  .mymsg{
    background-color:#d9fdd3!important;
  }
  .theme--dark .mymsg{
    background-color:#0b4811!important;
  }  
  #tags .v-list-item{
    float:left;
  }
  .vuse-content-wrapper {
    height: calc(100% - 5px)!important;
}
 .dialog_top{
  position:absolute;
  top:0;
}
</style>
<script>
import { mapGetters } from "vuex";
import { groupBy, find } from "lodash";
//import { groups, conversation, authUser, users } from "@/data/dummyData";
import { VueEditor  } from "vue2-editor";
import UserListNav from "./partials/UserListNav";
import ChatToolbar from "./partials/ChatToolbar";
import RightWindow from "./partials/RightWindow";
import InnerBaseLayout from "@/layouts/Inner/Layout";

export default {
  components: {
    InnerBaseLayout,
    UserListNav,
    ChatToolbar,
    RightWindow,
    VueEditor
  },
  computed: {
    ...mapGetters(["user","settings","orders","shippingServices","shipping_departures","active_status","active_carriers","carriers","status","shipping_options","departures","formattedTimeframe","shipping_envelopes"]),
    conversationGroup() {
      if(this.conversations){
        return groupBy(this.conversations, "group_id");
      }
      return [];
    },
    activeGroup() {
      if(this.groups)
      {
        console.log(446,this.groups,this.activeGroupId);
        console.log(447,find(this.groups, { id: this.activeGroupId }))
        return find(this.groups, { id: this.activeGroupId });
      }
      return null;
    },
    chat() 
    {
      console.log(454,this.activeGroupId,this.conversationGroup[this.activeGroupId])
      const group = this.activeGroupId;
      return this.conversationGroup[group];
    },
    filteredGroups() {
      if (this.groups)
      {
        console.log(461,this.groups,this.activeDeptId);
        const groups = this.groups.map((group) => {
          console.log(463,group,this.conversationGroup,this.conversationGroup[group.id])
          console.log(464,this.conversationGroup[group.id].slice(-1))
          const lastMsg =
            this.conversationGroup[group.id] !== undefined
              //? this.conversationGroup[group.id][0]
              ? this.conversationGroup[group.id].slice(-1)
              : null;
          return {
            ...group,
            msgOn: lastMsg ? lastMsg.created_at : 0,
            lastMsg,
          };
        });
        console.log(476,groups)
        //console.log(274,w2)
        var w= groups.filter((member) => member.user.name.toLowerCase().includes(this.search.toLowerCase()) && (member.user.deptId==this.activeDeptId||this.activeDeptId==null));
        console.log(479,w)
        return  w;
      }
      return [];
    },
  },  
  data() {
    return {
      page: "Tickets",
      snackbar:false,
      snackbar_color:'success',
      snackbar_message:'',
      snackbar_timeout:2000,
      createFAQ_dialog:false,
      tkt_dialog:false,
      FAQ_dialog:false,
      FAQsearch:'',
      QB_dialog:false,
      QB_loading:false,
      FAQSaved:false,
      QBSaved:false,
      depts_dialog:false,
      depts_loading:false,
      deptsSaved:false,
      edit_dialog:false,
      tpc_loading:false,
      tktSaved:false,
      tkt_loading:false,
      searchHints:null,
      qbtn:{},
      dpt:{},
      tpc:{},
      fq:{},
      tkt:{},
      FAQTab:null,
      search: "",
      QBColors:[{"name":"Blue","color":'info'},{"name":"Green","color":'success'},{"name":"Orange","color":'warning'},{"name":"Red","color":'error'}],
      //topics:['Impostazione Iniziale', 'Generare LDV', 'Inviare File', 'Pagamenti'],
      drawer: true,
      wIH:window.innerHeight,
      activeGroupId: 1,
      authUser:null,
      // Chat is always a group of members. For personal chat, it's restricted members (Only 2 members)
      // For personal chat, we just fetch other user's information to display in the list
      groups:null,
      // Get All conversation where auth user is member of the group
      // Not, conversation needs to be group by GroupID that's is.
      // For new, message push message on conversation object
      // It will automatically, manage the rest of the things.
      conversations:null,
      chatMessageEditor: '',
      timeout: null,
      taglist:null,
      topics:null,
      faqs:null,
      faqAdd_loading:false,
      activeDeptId:null,
      customToolbar: [
        //[{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline"],
        /*[
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],*/
        [{ list: "bullet" }],
        //[{ script: "sub" }, { script: "super" }],
        //[{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "image"],
      ],
      editTab:false,
      editTabs:['Depts','Topics','Quick Buttons'],
      tickLabels: ['Boss','','','','','Super Boss'],
      quick:null,
      depts:null,
      active_qbtnId:null,
      prev_active_qbtnId:null,
      active_dptId:null,
      prev_active_dptId:null,
      rating:0,
      prc:null
    };
  },
  created()
  {
      //this.$vuetify.theme.dark = true;
      if(window.localStorage.getItem('user'))
      {
        console.log(548);
        this.user=JSON.parse(window.localStorage.getItem('user'));
        this.authUser=this.user;
        console.log(551,this.authUser);
      }
      if (Object.entries(this.shipping_envelopes).length>0){
        console.log(554)
        this.loadData('OPEN')
      }
      else
      {
        this.reLog();
      }
      //console.log(282,this.groups,this.conversations, this.authUser);
  },
  methods: {
    reLog()
    {
      localStorage.setItem('target', this.$route.path);
      if ('username' in JSON.parse(localStorage.getItem('user')))
      {
        console.log(569)
        this.$router.push('/auth/lockscreen').catch(() => {});
      }
      else
      {
        console.log(574)
        this.$router.push('/auth/login').catch(() => {});
      }
    },
    topicFilter(item, queryText, itemText) {
      console.log(1079,item,queryText,itemText);
      const textOne = item.topic.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1 
    },
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      // An example of using FormData
      // NOTE: Your key could be different such as:
      // formData.append('file', file)

      var formData = new FormData();
      formData.append("image", file);

      //const res = await this.$http.post(url, formData );
      //console.log(527,res);
      
      this.$http.post({
        url: "/tickets/tickets.php",
        method: "POST",
        data: formData
      })
        .then(result => {
          const url = result.data.url; // Get url from response
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch(err => {
          console.log(err);
        });
        
    },
    addTextToChatMessageEditor(t) 
    {
      this.chatMessageEditor+=t;
    },
    selDept(d)
    {
      console.log(636,d);
      if (d)
      {
        this.activeDeptId=d;
      }
    },
    newTicketOpen(w)
    {
      console.log(809,w);
      this.tkt={};
      this.tktSaved=false;
      this.tkt_dialog=true;
    },  
    switchGroup(group) {
      // const ps = document.querySelector("#chatscrollstatesetter");
      // ps.scrollTop = 0;
      console.log(660,group);
      this.activeGroupId = group.id;
      this.chatMessageEditor='';
      this.$nextTick(() => {
        const container = this.$refs.conversations;
        container.scrollTop = container.scrollHeight;
      });
      // this.$nextTick(() => {
      //   ps.scrollTop = ps.scrollHeight;
      // });
    },
    drawerHandler() {
      this.drawer = !this.drawer;
    },
    fillQB()
    {
      this.active_qbtnId=this.active_qbtnId==this.prev_active_qbtnId?null:this.active_qbtnId;
      console.log(700,this.active_qbtnId,this.prev_active_qbtnId)
      if(this.active_qbtnId)
      {
        console.log(657,this.active_qbtnId)
        //this.qbtn=this.allQB[this.active_qbtnId];//.find(q =>q.id=this.qbtn.id);
        this.qbtn=this.quick.find(q =>q.id==this.active_qbtnId);
        console.log(659,this.qbtn);
      }
      else
      {
        this.active_qbtnId=null;
        this.qbtn={};
        console.log(713,this.active_qbtnId,this.qbtn)
      }
      this.prev_active_qbtnId=this.active_qbtnId;
    },
    fillDpt()
    {
      this.active_dptId=this.active_dptId==this.prev_active_dptId?null:this.active_dptId;
      console.log(878,this.active_dptId,this.prev_active_dptId)
      if(this.active_dptId)
      {
        console.log(881,this.depts,this.active_dptId)
        //this.qbtn=this.quick[this.active_qbtnId];//.find(q =>q.id=this.qbtn.id);
        this.dpt=this.depts.find(q =>q.deptId==this.active_dptId);
        console.log(884,this.dpt);
      }
      else
      {
        this.active_dptId=null;
        this.dpt={};
        console.log(890,this.active_dptId,this.dpt)
      }
      this.prev_active_dptId=this.active_dptId;
    },
    async searchTracking()
    {
      const t=this.tkt.trackingId;
      if (t.length>10)
      {
      console.log(653,t);
      var payload={"action":"searchTracking","payload":{"trackingId":t}};
      console.log(655,payload);
      //try
     // {
        var res=await this.saveData(payload);
        console.log(662,res);  
        switch (res.errorid)
        {
          case '0':
            sessionStorage.setItem('jwt', res.jwt);
            let p=res.payload;
            console.log(668,p.rc);
            this.prc=p.rc;        
            this.searchHints=p.rc?this.$t(this.page+'.Valid Tracking ID'):this.$t(this.page+'.Tracking ID not found yet');
            console.log(665,this.searchHints);
          break;
          case '0006':
            this.$router.push('/auth/login').catch(() => {});
          break;
          default:
            this.searchHints=this.$t(this.page+'.Tracking ID not found yet');
        }        
      }

    },
    async RateFAQ(value,id)
    {
      console.log(1235,value,id);
      var payload={"action":"FAQRate","payload":{"FAQId":id,"rating":value}};
      console.log(1237,payload);
      //try
     // {
        var res=await this.saveData(payload);
        console.log(1241,payload,res);  
        switch (res.errorid)
        {
          case '0':
            sessionStorage.setItem('jwt', res.jwt);
            let p=res.payload;
            this.snackbar=true;
            this.snackbar_color='success';
            this.snackbar_message=this.$t(this.page+'.Thanks')+'!';
            this.tpc={};
          break;

          case '0001':

          break;

          case '0006':
            this.$router.push('/auth/login').catch(() => {});
          break;
        }
      /*} catch(e)
      {
          //console.log(res.data);
            this.snackbar=true;
            this.snackbar_color='error';
            this.snackbar_message=e;
      }*/
   
    },    
    async bindTopic()
    {
      console.log(1139,this.tpc);
      this.tpc_loading= true;
      //this.qbtn.color=this.QBColors[this.qbtn.color].color;
      //var action=this.active_qbtnId!==null?'editQB':'addQB';
      //var action='QBAdd';
      var payload={"action":"topicBind","payload":this.tpc};
      console.log(1200,payload);
      //try
     // {
        var res=await this.saveData(payload);
        console.log(1204,payload,res);  
        switch (res.errorid)
        {
          case '0':
            sessionStorage.setItem('jwt', res.jwt);
            let p=res.payload;
            this.tpc_loading= false;
            console.log(1211,JSON.stringify(this.topics));
            this.topics.find(tp =>tp.topic==this.tpc.topic.topic).deptName=p.deptName;
            console.log(1213,this.topics);
            this.snackbar=true;
            this.snackbar_color='success';
            this.snackbar_message=this.$t(this.page+'.Done');
            this.tpc={};
          break;

          case '0001':

          break;

          case '0006':
            this.$router.push('/auth/login').catch(() => {});
          break;
        }
      /*} catch(e)
      {
          //console.log(res.data);
            this.snackbar=true;
            this.snackbar_color='error';
            this.snackbar_message=e;
      }*/
       this.tpc_loading= false;

    },   
    async addDepts(action='deptsAdd')
    {
      console.log(866,this.dpt);
      var old_buttonId=this.dpt.dptId||null;
      console.log(868,old_buttonId);
      this.depts_loading= true;
      //this.qbtn.color=this.QBColors[this.qbtn.color].color;
      //var action=this.active_qbtnId!==null?'editQB':'addQB';
      //var action='QBAdd';
      var payload={"action":action,"payload":this.dpt};
      console.log(874,payload);
      try
      {
        var res=await this.saveData(payload);
        console.log(878,payload,res);  
        switch (res.errorid)
        {
          case '0':
            this.deptsSaved=true;
            sessionStorage.setItem('jwt', res.jwt);
            let p=res.payload;
            let new_buttonId=p.buttonId;
            console.log(826,old_buttonId,new_buttonId)
            //console.log(827,JSON.stringify(this.quick));
            if(old_buttonId)
            {
              this.depts.map(qb => { 
                                      if (qb.id==old_buttonId){
                                            qb.id=new_buttonId
                                          }
                                    })
              console.log(895,JSON.stringify(this.depts));
            }
            else
            {
              this.depts.push(this.dpt);              
            }
            this.snackbar=true;
            this.snackbar_color='success';
            this.snackbar_message=this.$t(this.page+'.Done');            
          break;

          case '0001':

          break;

          case '0006':
            this.$router.push('/auth/login').catch(() => {});
          break;
        }
      } catch(e)
      {
          //console.log(res.data);
          this.snackbar=true;
          this.snackbar_color='error';
          this.snackbar_message=e;
      }
      this.depts_loading= false;
    },
    async addQB(action='QBAdd')
    {
      console.log(764,this.qbtn);
      var old_buttonId=this.qbtn.id||null;
      console.log(766,old_buttonId);
      this.QB_loading= true;
      //this.qbtn.color=this.QBColors[this.qbtn.color].color;
      //var action=this.active_qbtnId!==null?'editQB':'addQB';
      //var action='QBAdd';
      var payload={"action":action,"payload":this.qbtn};
      console.log(768,payload);
      try
      {
        var res=await this.saveData(payload);
        console.log(820,payload,res);  
        switch (res.errorid)
        {
          case '0':
            this.QBSaved=true;
            sessionStorage.setItem('jwt', res.jwt);
            let p=res.payload;
            let new_buttonId=p.buttonId;
            console.log(826,old_buttonId,new_buttonId)
            //console.log(827,JSON.stringify(this.quick));
            if(old_buttonId)
            {
              this.quick.map(qb => { 
                                      if (qb.id==old_buttonId){
                                            qb.id=new_buttonId
                                          }
                                    });
              console.log(838,JSON.stringify(this.quick));
            }
            else
            {
              this.quick.push(this.qbtn);              
            }
            this.snackbar=true;
            this.snackbar_color='success';
            this.snackbar_message=this.$t(this.page+'.Done');            
          break;

          case '0001':

          break;

          case '0006':
            this.$router.push('/auth/login').catch(() => {});
          break;
        }
      } catch(e)
      {
          //console.log(res.data);
          this.snackbar=true;
          this.snackbar_color='error';
          this.snackbar_message=e;
      }
      this.QB_loading= false;
    },
    createFAQ()
    {
      console.log(1403,this.chatMessageEditor);
      console.log(1404,this.conversationGroup[this.activeGroupId]);
      console.log(1405,this.conversationGroup[this.activeGroupId].slice(-1));
      this.createFAQ_dialog=true;
      this.FAQSaved=false;
      this.fq.topic='';
      this.fq.question=this.conversationGroup[this.activeGroupId].slice(-1)[0].message;
      this.fq.answer=this.chatMessageEditor.replaceAll('<p>','').replaceAll('</p>','\n');
      console.log(1411,this.topics);
    },
    editFAQ(faq){
      console.log(781,faq, this.faqs);
      //console.log(581,this.faqs.filter(f => f.faqId=faq.id));
      //const fqq=this.faqs.find(f=>f.faqId==faqId)
      //console.log(631,fqq);
      this.fq= {...faq};
      this.fq.tags=this.fq.tags.split(',');
      console.log(787,this.fq);
      this.createFAQ_dialog=true;
      /*
      this.fq= {...this.faqs.filter(f=> f.faqId=faqId)};
      this.fq.topic=this.faqs.filter(f =>f.topic);
      this.fq.question=this.faqs.filter(f = f.question);*/
      //this.fq.answer=this.chatMessageEditor.replaceAll('<p>','').replaceAll('</p>','');      

    },
    async addFAQ(){
      //console.log(472,this.faqId);
      this.faqAdd_loading=true;
      var payload={"action":"FAQAdd","payload":JSON.stringify(this.fq)};
      var res=await this.saveData(payload);
      this.faqAdd_loading=false;
      console.log(778,payload,res); 
      switch (res.errorid)
      {
        case '0':
          sessionStorage.setItem('jwt', res.jwt);
          this.FAQSaved=true;
          this.snackbar=true;
          this.snackbar_color='success';
          this.snackbar_message=this.$t(this.page+'.Done');               
        break;
        case '0006':
          this.$router.push('/auth/login').catch(() => {});
        break;
      } 

    },
    async deleteFAQ(faqId)
    {
      console.log(798,faqId);
      var payload={"action":"FAQDelete","faqId":faqId};
      var res=await this.saveData(payload);
      console.log(801,payload,res);      
      switch (res.errorid)
      {
        case '0':
          sessionStorage.setItem('jwt', res.jwt);
          this.FAQSaved=true;
          this.snackbar=true;
          this.snackbar_color='success';
          this.snackbar_message=this.$t(this.page+'.Done');               
        break;
        case '0006':
          this.$router.push('/auth/login').catch(() => {});
        break;
      } 
    },
    async createTicket(){
      console.log(1336,this.tkt);
      this.tkt_loading=true;
      var grp={...this.groups[0]};
      grp.id='not known yet';
      grp.conversations.body=this.tkt.body;
      grp.conversations.title=this.tkt.title;
      grp.user.topic=this.tkt.topic.topic;
      grp.user.deptId='new_deptId';
      grp.user.deptName='new_deptName';
      grp.last_message='new_lastMessage';
      console.log(920,grp);
      //this.conversations.unshift(msg); // for new messages on top
      //this.conversations.push(msg);
      var payload={"action":"newTicket","payload":this.tkt};

      //try {
        var res=await this.saveData(payload);
        console.log(927,payload,res);
        this.tkt_loading=false;
        switch (res.errorid)
          {
            case '0':
              this.tktSaved=true;
              sessionStorage.setItem('jwt', res.jwt);
              this.snackbar=true;
              this.snackbar_color='success';
              this.snackbar_message=this.$t(this.page+'.Saved');  

              let p=res.payload;
              console.log(939,p);
              grp.id=p.rc.id;
              grp.user.deptId=p.rc.deptId;
              grp.user.deptName=p.rc.deptName;
              grp.last_message=p.rc.last_message;
              this.groups.unshift(grp); 
              console.log(947,JSON.stringify(this.groups));              
            break;
            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
        /*} catch(e)
        {
            //console.log(res.data);
        }*/

      this.tkt.body = '';
      this.tkt.trackingId='';
      this.tk.title='';
      this.tkt.topic=''
      
    },
    async addTicket() {
      console.log(723,this.chatMessageEditor,this.authUser);
      
      const activeGroup = this.activeGroup;
      const avatar= this.authUser.avatar;
      const authUser = this.authUser;
      const date = new Date();
      const createdAt = date.getTime();
      var msg={
        avatar: avatar,
        group_id: activeGroup.id,
        user_id: authUser.id,
        user: authUser,
        message: this.chatMessageEditor.replaceAll('<p>','').replaceAll('</p>',''),
        created_at: createdAt,
        read: true,
        id:null
      };
      console.log(739,msg);
      //this.conversations.unshift(msg); // for new messages on top
      //this.conversations.push(msg);
      var payload={"action":"ticketAnswer","message":msg};

      //try {
        var res=await this.saveData(payload);
        console.log(745,payload,res);
        switch (res.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.jwt);
              let p=res.payload;
              console.log(914,p.ticketId,msg,this.conversations)
              msg.id=p.ticketId
              console.log(917,msg);
              this.conversations.push(msg);
              console.log(919,this.conversations);
              this.snackbar=true;
              this.snackbar_color='success';
              this.snackbar_message=this.$t(this.page+'.Done');                  
            break;
            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
        /*} catch(e)
        {
            //console.log(res.data);
        }*/

      this.chatMessageEditor = '';
      
      this.$nextTick(() => {
        const container = this.$refs.conversations;
        container.scrollTop = container.scrollHeight;
      });
    },
    async deleteTicket(thread)
    {
      console.log(676,thread);
      var payload={"action":"ticketDelete","ticketId":thread.id};
      var res=await this.saveData(payload);
      console.log(679,payload,res);
      switch (res.errorid)
        {
          case '0':
            sessionStorage.setItem('jwt', res.jwt);
            this.snackbar=true;
            this.snackbar_color='success';
            this.snackbar_message=this.$t(this.page+'.Done');   
            this.conversations.splice(this.conversations.findIndex(item => item.id === thread.id), 1)                 
          break;
          case '0006':
            this.$router.push('/auth/login').catch(() => {});
          break;
        }      
    },
    async forwardTicket(dept)
    {
      console.log(755,this.activeGroup);
      var ticketId=this.activeGroup.id;
      var payload={"action":"ticketForward","ticketId":ticketId,"deptId":dept.deptId};
      var res=await this.saveData(payload);
      console.log(759,payload,res); 
      switch (res.errorid)
        {
          case '0':
            let p=res.payload;
            this.activeGroup.user.deptName=p.deptName;
            sessionStorage.setItem('jwt', res.jwt);
            this.snackbar=true;
            this.snackbar_color='success';
            this.snackbar_message=this.$t(this.page+'.Done');                 
          break;
          case '0006':
            this.$router.push('/auth/login').catch(() => {});
          break;
        }         
    },
    async saveData(payload)
    {
      var url='/tickets/tickets.php';
      try
      {
          const res = await this.$http.post(url, JSON.stringify(payload) );
          console.log(575,res) 
          return res.data;
      }
      catch(e)
      {
          
          console.log(res.data);
      }          
    },
    async loadData(status='OPEN'){
      this.loading=true;
      try{
          const payload={"action":"getTicket","status":status}
          const res = await this.$http.post('/tickets/tickets.php', payload );
          console.log(781,res)        
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              let p=res.data.payload;
              this.conversations=p.conversations
              this.authUser=p.users[1];
              this.users=p.users.slice(1)||[];
              this.groups= p.groups;
              this.groups.map(u => {Object.assign(u.user, this.users.find(uu => uu.id==u.user.id))})
              this.activeGroupId=this.groups[0].id;//this.authUser=this.users[0];             
              this.groups.map(u => {Object.assign(u.conversations, this.conversations.find(c => c.group_id==u.id&&c.fullName!==undefined))})
              this.taglist=p.taglist;
              this.topics=p.topics;
              this.faqs=p.faqs;
              this.depts=p.depts;
              this.quick=p.quick;
              console.log(800,this.users,this.groups,this.conversations,this.authUser,this.taglist,this.topics,this.faqs,this.depts,this.quick);
              //console.log(JSON.stringify(this.faqs));
            break;

            case '0001':

            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
      } catch(e)
      {
          //console.log(res.data);
      }
      this.loading= false;
      this.$nextTick(() => {
        const container = this.$refs.conversations;
        container.scrollTop = container.scrollHeight;
      });
    },      
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    this.groups = null;
    this.conversations = null;
    delete this.groups;
    delete this.conversations;
  },
};
</script>
